module.exports = __webpack_public_path__ + "img/Bingo_Info_Game8.f612147a.png";